import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useState, useEffect } from "react";
import Global, { isValidAccount } from "../../util/Global";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import AdsFilter from "../../components/Ads/AdsComponents";
import AdsComponent from "../../components/Ads/AdsComponent";
import { GlobalData } from "../../util/GlobalData";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { DeliveryCountryContext } from "../../components/Utils";


const MyAds = () => {
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const { countries } = useContext(DeliveryCountryContext)

  const [filteredList, setFilteredList] = useState([]);
  const [adsList, setadsList] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)



  const ADS_URL = Global.backend + "/index.php/myAds";



  useEffect(() => {
    setpageNavLink({ path: "/dashboard/user/ajouterannonce", label: "filterannonce2.1" })
    setpageTitle("profileentreprise18.1")
    setalertTitle(!isValidAccount() && "invisibleAds")
    setnavLinks([])
  }, [])


  useEffect(() => {
    setisLoading(true)

    axios.all([axios.post(ADS_URL, { userId: localStorage.getItem("id") })])
      .then(axios.spread((adsResponse) => {



        setadsList(adsResponse.data);
      })).catch((err) => {
        showAlert("error", t("request.errorFetchingAdsDetails"))
      })
      .finally(() => {
        setisLoading(false)
      })
  }, []);








  return (
    <LoaderComponent isLoading={isLoading}>
      <div className="container-fluid bg-trasparent my-4 p-3">
        <div className="row">
          <AdsFilter title={t("navigation7.1")} adsList={adsList} setFilteredList={setFilteredList} categories={GlobalData.ads.categories} pays={countries} />

          <div className="col-md-9">
            <div className="container-fluid">
              <AdsComponent myAds={true} onClickEdit={true} itemsPerPage={8} items={filteredList} />
            </div>
          </div>
        </div>
      </div>
    </LoaderComponent>
  )

};

export default MyAds;